class CurrencyConverter {

    constructor() {
        this.converter = document.getElementById('currency_converter');
        this.total_price_no_discount_id = 'total_price_without_discount';
        this.converted_price_no_discount_id = 'converted_total_price_without_discount';
        this.total_price_with_extra_discount_id = 'total_price_with_extra_discount';
        this.conveted_price_with_extra_discount_id = 'converted_total_price_with_extra_discount'
    }

    init() {
        this.listenCurrencyConverter();
    }

    listenCurrencyConverter() {
        this.converter.addEventListener('change', (evt) => {
            const currencyRate = this.defineCurrencyRate(evt);
            const currencyCode = this.defineCurrencyCode(evt);

            this.convertPriceNoDiscount(currencyRate, currencyCode);
            this.convertPriceWithExtraDiscount(currencyRate, currencyCode);
        });
    }

    defineCurrencyCode(evt) {
        return evt.target[evt.target.selectedIndex].dataset.code;
    }

    defineCurrencyRate(evt) {
        return evt.target[evt.target.selectedIndex].value;
    }

    convertPriceNoDiscount(currencyRate, currencyCode) {
        let price = this.findTotalPrice(this.total_price_no_discount_id);
        let convertedPrice = this.convertPrice(currencyRate, price);

        this.setConvertedPrice(this.converted_price_no_discount_id, convertedPrice, currencyCode);
    }

    convertPriceWithExtraDiscount(currencyRate, currencyCode) {
        let price = this.findTotalPrice(this.total_price_with_extra_discount_id);
        let convertedPrice = this.convertPrice(currencyRate, price);

        this.setConvertedPrice(this.conveted_price_with_extra_discount_id, convertedPrice, currencyCode);
    }

    findTotalPrice(id) {
        return document.getElementById(id).dataset.value;
    }

    convertPrice(currencyRate, price) {
        const convertedPrice = currencyRate * price;

        return convertedPrice.toFixed(2);
    }

    setConvertedPrice(id, price, currencyCode) {
        document.getElementById(id).innerHTML = price.toString() + " " + currencyCode;
    }
}

export default CurrencyConverter;
